import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve } from '../../../../helpers/LinkMapper';

const fieldSchema = {
    "transitMode": [resolve.with(String)],
    "locationCode": [resolve.with(String)],
    "locationName": [resolve.with(String)]
};

class Location extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(Location, json, getResolvers(fieldSchema));
    }
}

export default Location;
